module.exports = __webpack_public_path__ + "static/img/beijing4.6d144de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/beijing4.jpg
// module id = IyC7
// module chunks = 1